import React from 'react';
import { BoothPageHeader, BoothCard, BoothCardHeader } from '../../../../components/BoothComponent';
import { useParams } from 'react-router-dom';
import useFetchStats from "../../../../hooks/useFetchStats";
import LoadingIndicator from "../../../../components/LoadingIndicator";

const Home = () => {
  const {data: stats, isFetching} = useFetchStats();

    const cardCommonClassName = "flex items-center justify-between font-semibold"

    return (
        <>
            <BoothPageHeader title={'Home'}>
              {isFetching && <LoadingIndicator className={"text-md"} />}
            </BoothPageHeader>
            <BoothCard>
                <BoothCardHeader>
                    <div className={cardCommonClassName}>
                        <p>Attendees</p>
                        <p>{stats?.attendees?.toFixed(0) || <>&mdash;</>} <span className="opacity-50">/{stats?.tickets?.toFixed(0) || <>&mdash;</>} attendees</span></p>
                    </div>
                </BoothCardHeader>
            </BoothCard>
            <BoothCard>
                <BoothCardHeader>
                    <div className={cardCommonClassName}>
                        <p>Donations</p>
                        <p>{stats?.donations?.toFixed(0) || <>&mdash;</>} donations</p>
                    </div>
                </BoothCardHeader>
            </BoothCard>
            <BoothCard>
                <BoothCardHeader>
                    <div className={cardCommonClassName}>
                        <p>Comments</p>
                        <p>{stats?.comments?.toFixed(0) || <>&mdash;</>} comments</p>
                    </div>
                </BoothCardHeader>
            </BoothCard>
            <BoothCard>
                <BoothCardHeader>
                    <div className={cardCommonClassName}>
                        <p>Chats</p>
                        <p>{stats?.messages?.toFixed(0) || <>&mdash;</>} messages</p>
                    </div>
                </BoothCardHeader>
            </BoothCard>
        </>
    )
}

export default Home
